import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b4c6cafa&scoped=true&"
import script from "./index.vue?vue&type=script&setup=true&lang=ts&"
export * from "./index.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=b4c6cafa&prod&scoped=true&lang=less&"
import style1 from "./index.vue?vue&type=style&index=1&id=b4c6cafa&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c6cafa",
  null
  
)

export default component.exports